<template>
  <section class="section-service col-12">
    <q-tab-panels v-model="panel" class="panel-services">
      <q-tab-panel class="panel-item" name="tab-1">
        <div class="title-page">Dados da solicitação</div>

        <q-form ref="formtab1">
          <div class="group-input col-12 row q-mt-sm">
            <label for="type-os">Tipo de OS</label>
            <q-select
              id="type-os"
              class="col-12 q-mt-sm form-tabulacao"
              outlined
              dense
              ref="typeOSRef"
              v-model="requestData.typeOS"
              color="red-9"
              @filter="getTypeOsByClassification"
              use-input
              hide-selected
              fill-input
              input-debounce="0"
              :options="optionsTypeOS"
              option-value="value"
              option-label="text"
              bg-color="white"
              :rules="[(val) => !!val || 'Campo Obrigatório']"
              lazy-rules
              disable
            />
          </div>

          <div class="group-input col-12 column q-mt-lg">
            <label for="write-off-code">Tipo de agendamento</label>
            <div class="flex row justify-around">
              <q-radio
                v-model="requestData.movimentTerminal"
                keep-color
                :val="1"
                size="lg"
                label="Realizar agendamento"
                color="red-6"
                :disable="true"
              />
              <q-radio
                v-model="requestData.movimentTerminal"
                keep-color
                :val="0"
                size="lg"
                label="Abertura imediata"
                color="red-6"
                :disable="true"
              />
            </div>
          </div>

          <!-- <div class="col-12 q-mt-lg">
            <label for="start">Opção 1</label>
            <q-input
              id="start"
              v-model="requestData.option1"
              bg-color="white"
              class="col-12 q-mt-sm"
              color="red-9"
              type="datetime-local"
              dense
              outlined
              :rules="[(val) => !!val || 'Campo Obrigatório']"
              lazy-rules
            />
          </div>

          <div class="col-12 q-mt-lg">
            <label for="conclusion_time">Opção 2</label>
            <q-input
              id="conclusion_time"
              v-model="requestData.option2"
              bg-color="white"
              class="col-12 q-mt-sm"
              color="red-9"
              type="datetime-local"
              dense
              outlined
              :rules="[(val) => !!val || 'Campo Obrigatório']"
              lazy-rules
            />
          </div> -->

          <div class="group-input col-12 row q-mt-sm">
            <label for="type-os">Opção 1</label>
            <div class="group-input col-12 row q-mt-sm flex justify-around">
              <q-select
                id="type-os"
                class="col-5 q-mt-sm form-tabulacao"
                outlined
                dense
                ref="typeOSRef"
                v-model="requestData.option1"
                color="red-9"
                use-input
                hide-selected
                fill-input
                input-debounce="0"
                :options="datesHoursAvailableForSelection.date"
                option-value="value"
                option-label="text"
                bg-color="white"
                lazy-rules
                :rules="[(val) => !!val || 'Campo Obrigatório']"
              />

              <q-select
                id="type-os"
                class="col-5 q-mt-sm form-tabulacao"
                outlined
                dense
                ref="typeOSRef"
                v-model="requestData.hourOption1"
                color="red-9"
                use-input
                hide-selected
                fill-input
                input-debounce="0"
                :options="datesHoursAvailableForSelection.hour"
                option-value="value"
                option-label="text"
                bg-color="white"
                lazy-rules
                :rules="[(val) => !!val || 'Campo Obrigatório']"
              />
            </div>
          </div>

          <div class="group-input col-12 row q-mt-sm">
            <label for="type-os">Opção 2</label>
            <div class="group-input col-12 row q-mt-sm flex justify-around">
              <q-select
                id="type-os"
                class="col-5 q-mt-sm form-tabulacao"
                outlined
                dense
                ref="typeOSRef"
                v-model="requestData.option2"
                color="red-9"
                use-input
                hide-selected
                fill-input
                input-debounce="0"
                :options="datesHoursAvailableForSelection.date"
                option-value="value"
                option-label="text"
                bg-color="white"
                lazy-rules
                :rules="[(val) => !!val || 'Campo Obrigatório']"
              />

              <q-select
                id="type-os"
                class="col-5 q-mt-sm form-tabulacao"
                outlined
                dense
                ref="typeOSRef"
                v-model="requestData.hourOption2"
                color="red-9"
                use-input
                hide-selected
                fill-input
                input-debounce="0"
                :options="datesHoursAvailableForSelection.hour"
                option-value="value"
                option-label="text"
                bg-color="white"
                lazy-rules
                :rules="[(val) => !!val || 'Campo Obrigatório']"
              />
            </div>
          </div>

          <div class="group-input col-12 row q-mt-sm">
            <label for="type-os"
              >Qual a quantidade de OS Instalar Cabeamento Mesh deverá ser
              gerada?</label
            >
            <q-input
              v-model="requestData.osQuantity"
              bg-color="white"
              class="col-12 q-mt-sm"
              color="red-9"
              type="number"
              :min="1"
              :max="8"
              dense
              outlined
              :rules="[
                (val) => !!val || 'Campo Obrigatório',
                (val) => val < 9 || 'Número valido entre 1 e 8']"
              lazy-rules
            />
          </div>

          <div class="group-input col-12 row q-mt-md">
            <label for="observation">Observação</label>
            <div class="col-12 row flex justify-around">
              <q-input
                v-model="requestData.observation"
                class="col-12 q-mt-sm"
                bg-color="white"
                color="red-9"
                maxlength="120"
                outlined
                autogrow
                :rules="[(val) => !!val || 'Campo Obrigatório']"
                lazy-rules
              />
            </div>
          </div> 
          </q-form
      ></q-tab-panel>
      <!-- <q-tab-panel class="panel-item" name="tab-2">
        <AttendanceClock ref="formtab2" :contract="requestData" />
      </q-tab-panel> -->
    </q-tab-panels>

    <div>
      <q-footer elevated>
        <q-toolbar>
          <div class="flex col-12 row items-center justify-between">
            <div
              class="col-8 div-progress q-pa-sm justify-center flex items-center"
              v-if="panel != 'tab-1'"
            >
              <q-linear-progress
                size="md"
                :value="progressBar"
                color="red-9"
                rounded
              />
            </div>
            <div
              class="col-12 justify-between flex items-center"
              v-if="panel == 'tab-1'"
            >
              <q-btn
                outline
                unelevated
                rounded
                color="red-9"
                @click="$emit('removeEdit')" 
                label="voltar"
              />
              <q-btn
                unelevated
                rounded
                color="red-9"
                @click="validateForm"
                label="Concluir"
              />
            </div>
            <div
              class="col-2 div-btn-next justify-center flex items-center"
              v-else
            >
              <q-btn
                round
                color="red-9"
                @click="addValueBarProgressAndAlterTab()"
                icon="arrow_forward"
              />
            </div>
          </div>
        </q-toolbar>
      </q-footer>
    </div>
  </section>
</template>

<script>
import DateTimePicker from "@/components/DateTimePicker";
import AttendanceClock from "@/components/generatedOsForm/AttendanceClock.vue";
import SelectCheckbox from "@/components/SelectCheckbox";
import { generateNextTenDays } from "@/utils/DateSchedules";
import moment from "moment";
import { useQuasar } from "quasar";
import { onMounted, reactive, ref } from "vue";

export default {
  name: "MeshForm",
  components: {
    SelectCheckbox,
    DateTimePicker,
    AttendanceClock,
  },
  props: {
    listWriteOffCode: Array,
    listTypeOS: Array,
    optionsWriteOffCode: Array,
    optionsTypeOS: Array,
    optionsTypeOSByClassification: Array,
    optionsActionOs: Array,
    optionsStateEquipaments: Array,
    itemOsContract: Object,
  },
  emits: [
    "saveSchemaRequest",
    "clearSchemaRequest",
    "removeEdit",
    "getTypeOsClassification",
    "disabledtabButton",
  ],

  setup(props, { emit }) {
    moment.locale("pt-br");

    const $q = useQuasar();
    const ACTION_INSTALLED_ID = ref(2);
    const ACTION_DEVOLUTION_ID = ref(3);
    const datesHoursAvailableForSelection = reactive({
      date: [],
      hour: [
        {
          id: 1,
          text: "08h - 12h",
          value: "08 - 12",
        },
        {
          id: 2,
          text: "12h - 15h",
          value: "12 - 15",
        },
        {
          id: 3,
          text: "15h - 18h",
          value: "15 - 18",
        },
      ],
    });

    let panel = ref("tab-1");
    let tabindex = ref(1);
    let progressBar = ref(0.5);

    let requestData = reactive(props.itemOsContract);

    let contract = reactive({
      osRequests: [],
    });

    let confirmationReplicateWriteOffCode = ref(false);
    let modalReplicateWriteOffCode = ref(false);

    let schemaRequest = reactive({
      object_id: "",
      osNumber: "",
      typeOS: "",
      statusOS: 1,
      writeOffCode: "",
      observation: "",
      check: false,
      replicate: false,
      source: "",
      action: 1,
      state: 1,
      equipamentNumberInstall: "",
      equipamentNumberDesinstall: "",
      cardNumberInstaled: "",
      cardNumberUninstalled: "",
    });
    const formtab1 = ref(null);
    const formtab2 = ref(null);

    const listTypeOS = ref([]);
    const listWriteOffCode = ref([]);

    const optionsItens = reactive({
      optionsTypeOS: listTypeOS,
      optionsWriteOffCode: listWriteOffCode,
    });

    function filterTypeOS(val, update) {
      update(() => {
        const needle = val.toLowerCase();
        optionsItens.optionsTypeOS = props.listTypeOS.filter(
          (v) => v.text.toLowerCase().indexOf(needle) > -1
        );
      });
    }

    function filterWriteOffCode(val, update) {
      update(() => {
        const needle = val.toLowerCase();
        optionsItens.optionsWriteOffCode = props.listWriteOffCode.filter(
          (v) => v.text.toLowerCase().indexOf(needle) > -1
        );
      });
    }

    function setTypeOsByServiceOption() {
      if (props.optionsTypeOS.length == 1) {
        requestData.typeOS = props.optionsTypeOS[0];
      }
    }

    function getTypeOsByClassification(val, update) {
      let selectedOption = props.optionsActionOs.find(
        (option) => option.id_acao == requestData.action
      );

      update(() => {
        optionsItens.optionsTypeOS = props.listTypeOS.filter((optionTypeOS) => {
          return (
            optionTypeOS.id_classificacao == selectedOption.id_classificacao
          );
        });
      });
    }

    function _getClassificationTypeName() {
      switch (requestData.action) {
        case 1:
          return "MANUTENÇÃO";
        case 2:
          return "INSTALAÇÃO";
        case 3:
          return "SERVIÇO";
      }
    }

    function openDialogEquipament(item, isInstall = true) {
      $q.dialog({
        title: "Confirme a numeração",
        message: item,
        cancel: true,
      })
        .onOk(() => {})
        .onCancel(() => {
          requestData.equipamentNumberInstall = "";
        });
    }

    async function validateForm() {
      let validation = false;
      validation = await formtab1.value.validate();
      if (validation) {
        await emitData();
      }
      return validation;
    }

    async function emitData() {
      emit("saveSchemaRequest", requestData);
      // emit("disabledtabButton", true);
    }

    function validateSchemaRequest() {
      if (
        requestData.osNumber == "" ||
        requestData.writeOffCode == "" ||
        requestData.typeOS == "" ||
        requestData.observation == ""
      ) {
        $q.notify({
          message: "Todos os campos são obrigatórios.",
          color: "red-9",
          position: "top",
          timeout: 3000,
        });
        return false;
      }
      return true;
    }

    function _changeTab() {
      const VALUE_INCREMENT_ID_TAB = 1;
      const STRING_ID_TAB = "tab-";

      tabindex.value += VALUE_INCREMENT_ID_TAB;
      panel.value = STRING_ID_TAB + tabindex.value;

      return true;
    }

    async function addValueBarProgressAndAlterTab() {
      const VALUE_MAX_BAR_PROGRESS = 1;
      const VALUE_ADD_PROGRESS = 0.5;

      if (
        progressBar.value != VALUE_MAX_BAR_PROGRESS &&
        (await validateForm())
      ) {
        let validateIfChangeTab = _changeTab();

        if (validateIfChangeTab) {
          progressBar.value += VALUE_ADD_PROGRESS;
        }
      }
    }

    async function removeTabValue() {
      const VALUE_ADD_PROGRESS = 0.5;
      tabindex.value = 1;
      progressBar.value = VALUE_ADD_PROGRESS;
      panel.value = "tab-1";
    }

    async function handleSetDefaulSchemeValueByType() {}

    function addDateSchedule() {
      datesHoursAvailableForSelection.date = generateNextTenDays();
    }

    onMounted(() => {
      requestData.movimentTerminal = 1;
      setTypeOsByServiceOption();
      addDateSchedule();
    });

    return {
      ACTION_INSTALLED_ID,
      ACTION_DEVOLUTION_ID,
      datesHoursAvailableForSelection,
      panel,
      tabindex,
      progressBar,
      schemaRequest,
      requestData,
      optionsItens,
      formtab1,
      formtab2,
      confirmationReplicateWriteOffCode,
      modalReplicateWriteOffCode,
      validateSchemaRequest,
      filterWriteOffCode,
      filterTypeOS,
      addValueBarProgressAndAlterTab,
      openDialogEquipament,
      validateForm,
      getTypeOsByClassification,
      removeTabValue,
    };
  },
};
</script>

<style scoped lang="scss">
label {
  font-family: Roboto;
  font-style: normal;
}

.q-page-container {
  padding-bottom: 0px !important;
}

.label-checkbox-confirm {
  font-weight: 500 !important;
  font-size: 12px !important;
  line-height: 14px !important;
  letter-spacing: 0.01em !important;
  color: #999999 !important;
}

footer {
  background: #e5e5e5 !important;
  height: 12vh;

  .q-toolbar {
    height: 12vh;
  }

  .div-progress {
    height: 8vh;
  }

  .div-btn-next {
    height: 8vh;
  }
}

.section-service {
  width: 100%;

  .panel-services {
    background: transparent !important;
    overflow: hidden !important;

    .title-page {
      font-weight: bold;
      font-size: 18px;
      line-height: 19px;
      text-transform: uppercase;
      color: #e2262d;
    }

    .group-input {
      label {
        font-weight: bold;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.4);
      }
    }

    .label-requests-number {
      font-weight: 600;
      font-size: 15px;
      line-height: 20px;
      color: rgba(0, 0, 0, 0.5);
    }

    .label-requests-description {
      font-weight: 500;
      font-size: 12px;
      line-height: 20px;
      color: rgba(0, 0, 0, 0.8);
    }
  }
}
</style>
